import React from "react";
import {useLanguageForShared} from "../../../../shared/utils/languages/useLanguageForShared";

export const EmptyMsg = () => {
    const {t} = useLanguageForShared()

    return <div>{t('lsi.noDataAvailable')}</div>
}
